import {lazy} from 'react';
import GenericFallbackSuspense from '../../../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const SplititOverlayBody = lazy(() => import('./SplititOverlayBody'/* webpackChunkName: 'SplititOverlayBody' */));

export default function SplititOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <SplititOverlayBody />
    </GenericFallbackSuspense>
  );
}
